var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2584_25096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6051 11.3869C22.1026 10.9223 20.7313 9.86242 18.8287 10.0149C17.5149 10.1238 16.5528 10.7553 16 11.2489C15.4472 10.7553 14.4851 10.1238 13.1713 10.0149C11.2687 9.86242 9.89744 10.9223 9.39487 11.3869C9.14359 11.6192 9 11.9604 9 12.3088V19.9819C9 20.4392 9.22974 20.8385 9.61744 21.0635C10.0051 21.2886 10.4933 21.2886 10.8882 21.0635C11.5846 20.657 12.3241 20.4755 13.0851 20.5409C14.4277 20.6498 15.2892 21.4701 15.5979 21.8185C15.6985 21.9347 15.8421 22 16 22C16.1579 22 16.2944 21.9347 16.4021 21.8185C16.7108 21.4701 17.5795 20.657 18.9149 20.5409C19.6759 20.4755 20.4154 20.657 21.1118 21.0635C21.5067 21.2958 21.9949 21.2958 22.3826 21.0635C22.7703 20.8385 23 20.432 23 19.9819V12.3088C23 11.9531 22.8564 11.6192 22.6051 11.3869ZM13.1713 19.452C13.0492 19.4447 12.92 19.4375 12.7908 19.4375C11.9508 19.4375 11.1108 19.6698 10.3426 20.1198C10.2492 20.1707 10.1774 20.1416 10.1487 20.1198C10.0985 20.0908 10.0697 20.04 10.0697 19.9819V12.3088C10.0697 12.3088 10.0769 12.2217 10.12 12.1854C10.6154 11.7281 11.6564 10.9804 13.0779 11.0965C14.2554 11.1909 15.0667 11.837 15.4544 12.2217V20.265C14.8944 19.8875 14.1262 19.5246 13.1641 19.4447L13.1713 19.452ZM21.9231 19.9819C21.9231 20.0472 21.8944 20.0908 21.8441 20.1198C21.8154 20.1344 21.7436 20.1707 21.6503 20.1198C20.7672 19.6044 19.7908 19.3721 18.8287 19.452C17.8667 19.5318 17.0985 19.8948 16.5385 20.2723V12.229C16.9262 11.837 17.7374 11.1981 18.9149 11.1038C20.3436 10.9876 21.3774 11.7353 21.8728 12.1927C21.9159 12.229 21.9231 12.2798 21.9231 12.3161V19.9892V19.9819Z",
    fill: "#2E3A59"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2584_25096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiscover);
export default __webpack_public_path__ + "static/media/icon_discover.c9f5af43.svg";
export { ForwardRef as ReactComponent };